import { PermissionCode } from '@gb-ticket/shared-types';

import { usePageTitle } from '@/hooks/use-page-title';
import { hasPermission } from '@/platform/auth/permissions';
import { useMe } from '@/platform/auth/use-me';
import { PlatformPageHeader } from '@/platform/components/platform-page-header';
import { useVoiceCopy } from '@/platform/voice/use-voice';
import { FleetTripsTable } from '@/products/fleet/features/fleet-trips-table';

export function FleetTripsPage() {
  usePageTitle('Meine Fahrten');
  const copy = useVoiceCopy();
  const me = useMe();
  const readOwn = hasPermission(me.data, PermissionCode.FLEET_TRIPS_READ_OWN);

  if (!readOwn) {
    return <p className="text-sm text-muted-foreground">{copy('fleet.trips.denied')}</p>;
  }

  return (
    <div className="space-y-6">
      <PlatformPageHeader title="Fahrten" description={copy('fleet.trips.description')} />
      <FleetTripsTable />
    </div>
  );
}
